import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const fetchCommunications = createAsyncThunk('communications/fetchMany', async (params) => {
    const response = await api.get('/communications', { params });
    return response.data;
});

export const fetchCommunicationById = createAsyncThunk('communications/fetchById', async (id) => {
    const response = await api.get(`/communications/${id}`);
    return response.data;
});

export const resendCommunication = createAsyncThunk('communications/resend', async (id) => {
    const response = await api.post(`/communications/${id}/resend`);
    return response.data;
});

const Slice = createSlice({
    name: 'communications',
    initialState: {
        list: [],
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalCount: 0,
            limit: 50,
            hasMore: false,
        },
        status: 'idle',
        error: null,
        selectedCommunication: null,
        selectedStatus: 'idle',
        selectedError: null,
    },
    reducers: {
        clearSelectedCommunication: (state) => {
            state.selectedCommunication = null;
            state.selectedStatus = 'idle';
            state.selectedError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCommunications.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCommunications.fulfilled, (state, action) => {
                state.status = 'success';
                state.list = action.payload.data || action.payload;
                state.pagination = action.payload.pagination || state.pagination;
                state.error = null;
            })
            .addCase(fetchCommunications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'An error occurred';
            })

            .addCase(fetchCommunicationById.pending, (state) => {
                state.selectedStatus = 'loading';
            })
            .addCase(fetchCommunicationById.fulfilled, (state, action) => {
                state.selectedStatus = 'success';
                state.selectedCommunication = action.payload;
                state.selectedError = null;
            })
            .addCase(fetchCommunicationById.rejected, (state, action) => {
                state.selectedStatus = 'failed';
                state.selectedError = action.error.message || 'An error occurred';
            });
    },
});

export const { clearSelectedCommunication } = Slice.actions;
export default Slice.reducer;
